import { Box, Button, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class Reglamentaria extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            consulta: false,
            codigosInforme: [],
            numeroNombre: [],
            lugaresTra: [],
            ubicacionesCentral: [],

            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
                codigo: '1',
                nombreFuncionario: sessionStorage.nombreFuncionario,
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: '',
                hasta: '',
                anio: '',
                dias: '',
                minutos: '',
                tipoMov: '2',
            }
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioInforme = this.manejoEnvioInforme.bind(this);
    }


    async componentDidMount(){

    }


    render() {
        return (
            <>
                <Container>
                    <br/>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                    <form onSubmit={this.manejoEnvioInforme}>
                        <fieldset>
                            <legend>Datos Formulario</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.1}>
                                        <Item>Ejercicio (AÑO)</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>
                                    <Grid item xs={1}>

                                    </Grid>
                                    <Grid item xs={2.1}>
                                        <Item>Días</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='dias' value={this.state.busqueda.dias} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>
                                    <Grid item xs={1}>

                                    </Grid>
                                    <Grid item xs={2.1}>
                                        <Item>Desde</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='desde' value={this.state.busqueda.desde} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>
                                    <Grid item xs={1}>

                                    </Grid>
                                    <Grid item xs={2.1}>
                                        <Item>Hasta</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='hasta' value={this.state.busqueda.hasta} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                            <Box>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={3}>
                                        <Item><button className="btn btn-outline-primary" type='submit'> {this.state.modificar ? 'Modificar' : 'Confirmar'}</button></Item>
                                    </Grid>
                                    <Grid item xs={3} >
                                        {this.state.modificar ? <Item><button type="button" className="btn btn-outline-primary" onClick={this.darDeBaja}> Dar de Baja</button></Item> : ''}
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                    </form>
                </Container>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioInforme(e){
        e.preventDefault();
        if(this.state.busqueda.anio === ''){
            this.setState({
                errores: 'DEBE INGRESAR EL AÑO DEL EJERCICIO',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.busqueda, 0]);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/contrlar_movimiento.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();

            this.setState({
                errores: res,
            });

            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    busqueda: {
                        numeroFuncionario: sessionStorage.numeroFuncionario,
                        codigo: '1',
                        nombreFuncionario: sessionStorage.nombreFuncionario,
                        ubicacionBusqueda: '',
                        ubicacionCentral: '',
                        desde: '',
                        hasta: '',
                        anio: '',
                        dias: '',
                        minutos: '',
                        tipoMov: '2',
                    }
                });
            }
        }
    }

}

export default Reglamentaria